let totalUnreadCount = 0;

function normalizeUnreadCount(raw) {
  const n = Number(raw);
  if (!Number.isFinite(n) || n < 0) return 0;
  return Math.floor(n);
}

export function getTotalUnreadCount() {
  return totalUnreadCount;
}

export function setTotalUnreadCount(count) {
  totalUnreadCount = normalizeUnreadCount(count);
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent("chatUnreadUpdated"));
}
